var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto lg:m-auto border-2 rounded p-4 w-full"},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player-box",attrs:{"options":_vm.video}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }